module.exports = __webpack_public_path__ + "img/2022.2.43542a75.png";